import React, { useEffect } from "react";
import { ButtonReusableComponent } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";

import { Dialog } from "@material-ui/core";
import { DialogContent } from "@material-ui/core";
import { DialogContentText } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logOutUser } from "../../../store/actions/authAction";
import SocketContext from "../../../function/SocketContext";

function SessionPopup(props) {
  // const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (props?.open) {
      handleClickOpen();
    }
  }, [props?.open]);

  const handleClose = () => {
    setOpen(false);
  };

  const adminLogin = () => {
    dispatch(logOutUser());
    handleClose();
    history.push("/admin-login");
  };

  return (
    <div>
      <Dialog
        open={open}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        // disableBackdropClick
      >
        {/* <DialogTitle id="alert-dialog-title">
          {"Use Google's location service?"}
        </DialogTitle> */}
        <DialogContent className="text-center">
          <DialogContentText id="alert-dialog-description">
            <div className="f16-700">Session Timeout</div>
            <div className="mt-2 f12-400">
              Sorry, your session timed out after a long time of inactivity.{" "}
              <br />
              Please login again to continue working.
            </div>
            <div className="mt-3">
              <ButtonReusableComponent
                buttonText="Login"
                buttonType="Submit"
                buttonClass={"activeLogin"}
                onClick={adminLogin}
              />
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}

const SessionPopupComponent = (props) => (
  <SocketContext.Consumer>
    {(socket) => <SessionPopup {...props} socket={socket} />}
  </SocketContext.Consumer>
);

export default SessionPopupComponent;
